// extracted by mini-css-extract-plugin
export default {"authWrapper":"AuthorizationCall_authWrapper__0EG3q","authText":"AuthorizationCall_authText__8IGdc","authBtn":"AuthorizationCall_authBtn__iHU0-"};